import { isTruthy } from "@vega-core/utils/isTruthy";

export function setUrlParam(key: string, value: string | undefined) {
  const url = new URL(window.location.href);

  if (isTruthy(value)) {
    url.searchParams.set(key, value);
  } else {
    url.searchParams.delete(key);
  }

  window.history.replaceState({}, "", url);
}

export function getUrlParam(key: string) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  return urlParams.get(key);
}

/**
 * Creates a URL-safe slug from text by converting to lowercase,
 * replacing spaces with hyphens, and removing special characters
 *
 * @param text - The text to convert to a slug
 * @returns URL-safe slug
 *
 * @example
 * createUrlSlug("Hello World") // "hello-world"
 * createUrlSlug("User's Guide!") // "users-guide"
 */
export const createUrlSlug = (text: string): string =>
  text
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");

/**
 * Updates the browser URL hash without triggering a page scroll
 *
 * @param hash - The hash value to set (without #)
 */
export const updateUrlHash = (hash: string): void => {
  if (typeof window !== "undefined") {
    window.history.pushState(null, "", `#${hash}`);
  }
};

/**
 * Gets the current URL hash (without the # symbol)
 *
 * @returns Current URL hash or empty string if none
 */
export const getCurrentHash = (): string => {
  if (typeof window !== "undefined") {
    return window.location.hash.slice(1);
  }

  return "";
};

const EMBEDDABLE_VIDEO_HOSTS = new Set([
  "youtube.com",
  "www.youtube.com",
  "m.youtube.com",
  "youtu.be",
  "vimeo.com",
  "www.vimeo.com",
  "player.vimeo.com",
]);

export const isEmbeddableVideoUrl = (rawUrl: string): boolean => {
  try {
    const { hostname } = new URL(rawUrl);

    return EMBEDDABLE_VIDEO_HOSTS.has(hostname.toLowerCase());
  } catch {
    return false;
  }
};
